import React from 'react'

const AgeLists = (props) => {
    return (
        <span>
            {
            props.ages.map((age, index) => {
                return <>{`${age}${index + 1 !== props.ages.length ? ', ' : ''}`}</>
            })
        }
        </span>
        

    )
};

export default AgeLists;
